import { NgModule } from '@angular/core';

import { AddCustomerFromBranchComponent }        from './customer.add-from-branch.component';
import { ChangeCustomerComponent }               from './customer.change.component';
import { CustomerActionsComponent }              from './customer.actions.component';
import { CustomerActivityLogsComponent }         from './customer.activity-logs.component';
import { CustomerBranchHistoryComponent }        from './customer.branch-history.component';
import { CustomersComponent }                    from './customers.component';
import { CustomerSearchControlComponent }        from './customer.search-control.component';
import { CustomersService }                      from './customers.service';
import { CustomerStatementFieldsComponent }      from './customer.statement-fields.component';
import { CustomerStatementSettingsComponent }    from './customer.statement-settings.component';
import { CustomerTypePipe }                      from './customer.type.pipe';
import { EmailCustomerStatementComponent }       from './customer.email-statement.component';
import { ResolveCustomerMatchesComponent }       from './customer.resolve-matches.component';
import { SendCustomerPortalInvitationComponent } from './customer.send-portal-invitation.component';
import { SharedModule }                          from '../shared/shared.module';
import { TableModule }                           from '../table/table.module';

@NgModule({
  declarations: [
    AddCustomerFromBranchComponent,
    ChangeCustomerComponent,
    CustomerActionsComponent,
    CustomerActivityLogsComponent,
    CustomerBranchHistoryComponent,
    CustomersComponent,
    CustomerSearchControlComponent,
    CustomerStatementFieldsComponent,
    CustomerStatementSettingsComponent,
    CustomerTypePipe,
    EmailCustomerStatementComponent,
    ResolveCustomerMatchesComponent,
    SendCustomerPortalInvitationComponent
  ],
  entryComponents: [
    AddCustomerFromBranchComponent,
    ChangeCustomerComponent,
    CustomerActionsComponent,
    CustomerActivityLogsComponent,
    CustomerBranchHistoryComponent,
    CustomersComponent,
    CustomerStatementSettingsComponent,
    EmailCustomerStatementComponent,
    ResolveCustomerMatchesComponent,
    SendCustomerPortalInvitationComponent
  ],
  imports: [
    SharedModule,
    TableModule
  ],
  providers: [
    CustomersService,
    CustomerTypePipe,

    // Pipes must also be provided via string
    // if they are going to be used in a table
    // column. This allows the injector to be
    // able to load a pipe dynamically in the
    // TableCellComponent.
    {
      provide : 'customerType',
      useClass: CustomerTypePipe
    }
  ]
})
export class CustomersModule {}
